/**
 * Linckle Cart Attributes Script — reference script (work-item: discount-link-product-landing, T4).
 *
 * 이 스크립트는 **우리 백엔드가 배포하지 않는다**. Linckle 팀이 Shopify 테마(theme.liquid 등
 * 전역 레이아웃)에 1회 수동 설치한다. 단일 스토어 마켓플레이스 구조라 광고주별 설치가 필요 없다.
 *
 * 목적: 할인링크 착지가 cart permalink → 상품페이지로 바뀌면서(2026-07 결정) 사라진 cart
 * attributes(linckle_*) → note_attributes 경로를 복원한다. 정산 귀속(link-attribution.service.ts)
 * 의 유일한 운반체다 — 이 스크립트가 미설치/실패하면 해당 세션의 주문은 전부 CODE_ONLY(수동 검토)
 * 로 강등된다(정산 유실은 없음, 자동화만 빠짐).
 *
 * custom-pixel.js(Web Pixel, 샌드박스)와는 자매 스크립트지만 별개다 — 픽셀은 텔레메트리 전용
 * (정산 불참여, event.context.document.location 만 신뢰), 이 스크립트는 일반 테마 JS 컨텍스트에서
 * 실행되므로 window.location/document/fetch/sessionStorage 를 직접 쓸 수 있다.
 *
 * **로직은 순수 함수로 분리돼 TS 로 테스트된다**(src/core/project-link/domain/services/
 * cart-attributes-script.logic.ts, jest 커버). 이 파일은 그 로직의 런타임 JS 미러다 — **두 파일을
 * 함께 수정할 것.** LINCKLE_KEYS·extractLinckleAttrs·resolveAttrs·shouldSyncCartAttributes·
 * buildCartUpdatePayload·CART_UPDATE_MAX_ATTEMPTS 가 TS 쪽과 반드시 동일해야 한다.
 *
 * 설계: 담기(add-to-cart) 버튼 클릭을 가로채지 않는다. 테마마다 담기 버튼/이벤트가 달라 셀렉터
 * 훅킹은 깨지기 쉽다. 대신 페이지 로드 시 linckle_* 귀속이 있으면 즉시 POST /cart/update.js 로
 * attributes 를 선반영한다 — Shopify cart attributes 는 장바구니가 비어있어도 설정 가능하고 세션
 * 내내 유지되며 이후 담긴 상품/체크아웃까지 그대로 이어진다.
 *
 * 알려진 제약: buy-now(즉시 체크아웃) 버튼은 일부 테마/가속결제에서 /cart/update.js 를 경유하지
 * 않고 바로 체크아웃에 진입할 수 있다 — 이 경로는 스크립트가 attributes 를 부착할 기회가 없어
 * 항상 CODE_ONLY 로 귀속된다(제품 결정: 감수).
 */

(function () {
  var STORAGE_KEY = 'linckle_attrs_v1';
  var CART_UPDATE_URL = '/cart/update.js';
  var LINCKLE_KEYS = [
    'linckle_link',
    'linckle_via',
    'linckle_ts',
    'linckle_sig',
    'linckle_project',
    'linckle_partner',
    'linckle_channel',
  ];
  var CART_UPDATE_MAX_ATTEMPTS = 2;

  // TS extractLinckleAttrs 미러. bare(`key=value`)와 attributes[] 래핑(`attributes[key]=value`)
  // 두 표기 모두 허용(custom-pixel.js extractLinckleAttrs 와 동일 우선순위: 래핑 우선).
  function extractLinckleAttrs(search) {
    try {
      var params = new URLSearchParams(search);
      var attrs = {};
      for (var i = 0; i < LINCKLE_KEYS.length; i++) {
        var key = LINCKLE_KEYS[i];
        var v = params.get('attributes[' + key + ']') || params.get(key);
        if (v) attrs[key] = v;
      }
      return Object.keys(attrs).length ? attrs : null;
    } catch (e) {
      return null;
    }
  }

  // TS resolveAttrs 미러(last-write-wins). URL 에 새 값이 있으면 항상 덮어쓴다.
  function resolveAttrs() {
    var fromUrl = extractLinckleAttrs(window.location.search);
    if (fromUrl) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl));
      } catch (e) {
        /* storage 차단 환경 — URL 캡처본만 사용 */
      }
      return fromUrl;
    }
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  }

  // TS shouldSyncCartAttributes 미러.
  function shouldSyncCartAttributes(attrs) {
    return !!attrs && Object.keys(attrs).length > 0;
  }

  // TS buildCartUpdatePayload 미러. bare 키(attributes[] 래핑 없음) — Shopify note_attributes 저장
  // 키와 동일 계약.
  function buildCartUpdatePayload(attrs) {
    return { attributes: attrs };
  }

  function syncCartAttributes(attrs, attempt) {
    fetch(CART_UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildCartUpdatePayload(attrs)),
      keepalive: true,
    }).catch(function () {
      // 네트워크 일시 오류만 흡수 — 무한 재시도 금지(CART_UPDATE_MAX_ATTEMPTS 상한).
      if (attempt < CART_UPDATE_MAX_ATTEMPTS) {
        syncCartAttributes(attrs, attempt + 1);
      }
      // 최종 실패해도 페이지/체크아웃은 막지 않는다 — note_attributes 미부착으로 CODE_ONLY 강등만
      // 발생(정산 유실 없음, link-attribution.service.ts 의 heldOrder 폴백이 안전망).
    });
  }

  function run() {
    var attrs = resolveAttrs();
    if (!shouldSyncCartAttributes(attrs)) return; // linckle 링크가 아닌 방문은 건드리지 않는다.
    syncCartAttributes(attrs, 1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
